export default __webpack_public_path__ + "static/0083-7a8c473a74587b10d9b2c3fc9ee146a8.png";